import { render } from "./zoomLinkComponent.vue?vue&type=template&id=c9c8257e&scoped=true"
import script from "./zoomLinkComponent.vue?vue&type=script&lang=js"
export * from "./zoomLinkComponent.vue?vue&type=script&lang=js"

import "./zoomLinkComponent.vue?vue&type=style&index=0&id=c9c8257e&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c8257e"]])

export default __exports__